import { render, staticRenderFns } from "./import-table.vue?vue&type=template&id=39ac1370&scoped=true"
import script from "./import-table.vue?vue&type=script&lang=js"
export * from "./import-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ac1370",
  null
  
)

export default component.exports